import { types } from 'mobx-state-tree';

export const TicketListTypeSelectorItemStore =
    types.model({
        title: types.string,
        path: types.string
    });

const TicketListTypeSelectorIndexOfVG = 1;

export const TicketListTypeSelectorStore =
    types.model({
        items: types.array(TicketListTypeSelectorItemStore),
        activeIndex: types.number
    }).actions((self) => {
        const setActiveItem = (index: number): void => {
            self.activeIndex = index;
        }

        const setVGAsActive = (): void => {
            self.activeIndex = TicketListTypeSelectorIndexOfVG;
        }

        return {
            setActiveItem,
            setVGAsActive
        }
    });